import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballOrganizerService } from "../../../../../commons";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { FootballOrganizer } from "../../../../../commons/models/football/football-organizer";
import { IFootballOrganizer } from "../../../../../commons/models/football/interface/i-football-organizer";

export interface IFootballOrganizerInfoState {
  footballOrganizerInfo: IFootballOrganizer;
  footballOrganizerInfoStatus: StatusEnum;
}

const initialState: IFootballOrganizerInfoState = {
  footballOrganizerInfo: new FootballOrganizer(),
  footballOrganizerInfoStatus: StatusEnum.Idle,
};

export const fetchFootballOrganizer = createAsyncThunk(
  "manage/fetchFootballOrganizer",
  async (footballOrganizerId: number, thunkAPI) => {
    try {
      const match = await manageFootballOrganizerService.find(footballOrganizerId);
      return match;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageFootballOrganizerSlice = createSlice({
  name: "FootballOrganizer",
  initialState: initialState,
  reducers: {
    cleanUpFootballOrganizerInfo(state) {
      state.footballOrganizerInfo = new FootballOrganizer();
      state.footballOrganizerInfoStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFootballOrganizer.pending, (state) => {
        state.footballOrganizerInfoStatus = StatusEnum.Loading;
      })
      .addCase(fetchFootballOrganizer.fulfilled, (state, action: PayloadAction<FootballOrganizer>) => {
        state.footballOrganizerInfoStatus = StatusEnum.Succeeded;
        state.footballOrganizerInfo = action.payload;
      })
      .addCase(fetchFootballOrganizer.rejected, (state) => {
        state.footballOrganizerInfoStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpFootballOrganizerInfo } = manageFootballOrganizerSlice.actions;
export default manageFootballOrganizerSlice.reducer;
